import { ColumnDataType, Provider, WorkflowComponentCodeParams, WorkflowComponentParamType } from '../types'
import { SelectWorkflowComponent } from './common/selectcomponent'

const actions = new Map([
  ['Combine Objects', 'ST_UNION($1, $2)'],
  ['Cut 1st From 2nd', 'ST_DIFFERENCE($1, $2)'],
  ['Cut 2nd From First', 'ST_DIFFERENCE($2, $1)'],
  ['Create Intersection Object', 'ST_INTERSECTION($1, $2)'],
  ['Create Inverse Intersection Object', 'ST_DIFFERENCE(ST_UNION($1, $2), ST_INTERSECTION($1, $2))']
])

class SpatialProcess extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'alteryx.spatialprocess',
        group: 'Spatial Constructors',
        title: 'Spatial Process',
        description: `
                    This component performs high-level spatial object editing from a simple, single component.
                    You can combine multiple objects or cut the spatial objects of the input table.
                    `,
        tags: ['alteryx']
      },
      [
        {
          name: 'table',
          type: WorkflowComponentParamType.InputTable,
          title: 'source table'
        },
        {
          name: 'cola',
          type: WorkflowComponentParamType.Column,
          title: '1st Spatial Field',
          parent: 'table',
          dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
        },
        {
          name: 'colb',
          type: WorkflowComponentParamType.Column,
          title: '2nd Spatial Field',
          parent: 'table',
          dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
        },
        {
          name: 'transformation',
          type: WorkflowComponentParamType.Selection,
          title: 'Action',
          default: actions.keys().next().value,
          optional: true,
          options: Array.from(actions.keys())
        }
      ]
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    if (connection.type !== Provider.BigQuery) {
      return null
    }
    const transformation = (actions.get(params.transformation as string) ?? (actions.keys().next().value as string))
      .split('$1')
      .join(params.cola as string)
      .split('$2')
      .join(params.colb as string)
    return `SELECT
            ${transformation} AS spatialprocess,
            *
            FROM \`${params.table}\``
  }
  supportedProviders(): Provider[] {
    return [Provider.BigQuery]
  }
}

export { SpatialProcess }
